export const enum AISummaryStatus {
  Pending = "pending",
  Complete = "complete",
  Failed = "failed",
}

export interface AISummary {
  text: string;
  created: string;
  status: AISummaryStatus;
}
